module.exports = __webpack_public_path__ + "static/sync_calendar-6d00c07c069d8e5d4b73f00e32082260.gif";